import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/assets/css/element-variables.scss'
import '@/assets/css/index.scss'
import '@/assets/css/base.scss'
import Home from './App.vue'
import router from './router'
import request from '@/plugins/request'
import qs from 'qs'
import Config from '@/config'
import i18n from './locale/i18n/i18n'
import '@/utils/permission.js'
import dayjs from 'dayjs'
import {parseTime} from '@/utils/DateUtils.js'

import { GetWriteOffTypeName, GetWriteOffStatusName } from '@/utils/index.js'
Vue.prototype.$request = request
Vue.prototype.$qs = qs
Vue.prototype.$Config = Config
Vue.prototype.$parseTime = parseTime
Vue.prototype.i18n = i18n
Vue.prototype.dayjs = dayjs

Vue.use(ElementUI)

// 千位符
Vue.filter('numFormat', function(num) {
  if (num) {
    num = num.toString().split('.')
    const arr = num[0].split('').reverse()
    let res = []
    for (let i = 0; i < arr.length; i++) {
      if (i % 3 === 0 && i !== 0) {
        res.push(',')
      }
      res.push(arr[i])
    }
    res.reverse()
    if (num[1]) {
      res = res.join('').concat('.' + num[1])
    } else {
      res = res.join('') // .concat('.00')
    }
    return res
  } else {
    return '0' // '0.00'
  }
})
// 日期格式化
// formatString = YYYY-MM-DD | YYYY-MM-DD HH:mm:ss
Vue.filter('dateFormat', function(date, formatString) {
  if (date) {
    return dayjs(date).format(formatString)
  } else {
    return ''
  }
})
// 核销类型数据名称
Vue.filter('getWriteOffTypeName', function(data) {
  return GetWriteOffTypeName(data)
})
// 核销状态数据名称
Vue.filter('getWriteOffStatusName', function(data) {
  return GetWriteOffStatusName(data)
})

new Vue({
  router,
  i18n,
  render: h => h(Home)
}).$mount('#app')
